var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-level",class:'level-'+_vm.color},[_c('div',{staticClass:"level-inner"},[_vm._v(_vm._s(_vm.level))])])
}
var staticRenderFns = []

export { render, staticRenderFns }